import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as tiimStudyParticipantActions from './tiim-study-participant.actions';
import { TiimStudyParticipant } from '../../../../models/tiim-study-participant';

export const tiimStudyParticipantFeatureKey = 'tiimStudyParticipant';

export const tiimStudyParticipantAdapter: EntityAdapter<TiimStudyParticipant> = createEntityAdapter<TiimStudyParticipant>(
  {}
);

export interface TiimStudyParticipantState extends EntityState<TiimStudyParticipant> {
  loadingTiimStudyParticipants: boolean;
  tiimStudyParticipantsLoaded: boolean;
  selectedTiimStudyParticipant: TiimStudyParticipant;
  singleParticipantVisible: boolean;
}

export const initialTiimStudyParticipantState: TiimStudyParticipantState = tiimStudyParticipantAdapter.getInitialState({
  loadingTiimStudyParticipants: false,
  tiimStudyParticipantsLoaded: false,
  selectedTiimStudyParticipant: null,
  singleParticipantVisible: false,
});

export const reducer = createReducer(
  initialTiimStudyParticipantState,
  on(tiimStudyParticipantActions.getTiimStudyParticipants, (state) => {
    return {
      ...state,
      loadingTiimStudyParticipants: true,
      tiimStudyParticipantsLoaded: false,
      singleParticipantVisible: false,
    };
  }),
  on(tiimStudyParticipantActions.getTiimStudyParticipantsSuccess, (state, { tiimStudyParticipants }) => {
    return tiimStudyParticipantAdapter.setAll(tiimStudyParticipants, {
      ...state,
      loadingTiimStudyParticipants: false,
      tiimStudyParticipantsLoaded: true,
    });
  }),
  on(tiimStudyParticipantActions.getTiimStudyParticipantsError, (state) => {
    return {
      ...state,
      loadingTiimStudyParticipants: false,
      tiimStudyParticipantsLoaded: false,
    };
  }),
  on(tiimStudyParticipantActions.deleteTiimStudyParticipantSuccess, (state, { deletedTiimStudyParticipantId }) => {
    return tiimStudyParticipantAdapter.removeOne(deletedTiimStudyParticipantId, {
      ...state,
    });
  }),
  on(tiimStudyParticipantActions.setSelectedTiimStudyParticipant, (state, { selectedTiimStudyParticipant }) => {
    return {
      ...state,
      selectedTiimStudyParticipant,
    };
  }),
  on(tiimStudyParticipantActions.setSingleTiimStudyParticipantPageVisibility, (state, { singleParticipantVisible }) => {
    return {
      ...state,
      singleParticipantVisible,
    };
  }),
  on(tiimStudyParticipantActions.enrolTiimStudyParticipantSuccess, (state, { enrolledTiimStudyParticipant }) => {
    return tiimStudyParticipantAdapter.updateOne(
      {
        id: enrolledTiimStudyParticipant.id,
        changes: enrolledTiimStudyParticipant,
      },
      {
        ...state,
        singleParticipantVisible: false,
      }
    );
  })
);

export function tiimStudyParticipantReducer(state: TiimStudyParticipantState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectAll } = tiimStudyParticipantAdapter.getSelectors();
